import * as React from 'react';
import { getUserApi, logInApi } from '../api/api';
import BtnFilled from '../components/BtnFilled';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUserStore } from '../stores/use-user-store';
import ResetPassword from '../features/login/ResetPassword';
import { ControlledCheckbox } from '../components/Checkbox';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledInputPassword from '../components/ControlledInputPassword';
import { COMMON_FORM_ERRORS } from '../constants';
import ControlledInput from '../components/ControlledInput';
import { useState } from 'react';
import { ROLES } from '../hooks/use-role';

const Login = () => {
  const { setUser, setAuthorized } = useUserStore();
  const testLogIn =
    process.env.REACT_APP_MODE === 'dev'
      ? {
          email: 'rise33@yandex.ru',
          password: '$outh3*3Cross',
        }
      : {};

  const methods = useForm({ mode: 'onTouched', defaultValues: testLogIn });

  const [showAddModal, setShowAddModal] = useState(false);

  const handleSubmit = async (data) => {
    const { isEngineer, ...rest } = data;
    const formData = { ...rest, ...(isEngineer && { role: ROLES.ENGINEER }) };
    await logInApi(
      formData,
      async function (data) {},
      function (err) {
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
      }
    );

    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
      },
      function (err) {
        setAuthorized(false);
      }
    );
  };

  return (
    <div className="w-full max-w-lg">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)} className="bg-white shadow-2xl rounded-b-3xl border-b border-x border-gray-300 px-8 pt-6 pb-8 mb-4">
          <ControlledInput
            label="Email"
            name={'email'}
            autoComplete="email"
            classContainer={'mb-4'}
            placeholder={'someone@example.com'}
            rules={{
              required: {
                value: true,
                message: COMMON_FORM_ERRORS.REQUIRED,
              },
            }}
          />

          <ControlledInputPassword
            label="Пароль"
            classContainer={'mb-4'}
            name={'password'}
            autoComplete="current-password"
            rules={{
              required: {
                value: true,
                message: COMMON_FORM_ERRORS.REQUIRED,
              },
            }}
          />

          <ControlledCheckbox labelClassName={'text-gray-700'} control={methods.control} name={'isEngineer'} label={'Войти как инженер'} />
          <BtnFilled
            className={'my-4'}
            type={'submit'}
            title={
              methods.formState.isSubmitting ? (
                <div
                  className="inline-block h-5 w-5 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                  role="status"
                />
              ) : (
                'Войти'
              )
            }
          />

          <BtnFilled title="Сбросить пароль" btnCb={() => setShowAddModal(true)} />
        </form>
      </FormProvider>
      <ResetPassword showAddModal={showAddModal} setShowAddModal={setShowAddModal} />
    </div>
  );
};

export default Login;
